/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bronze_Weak_Ape_PushInputs */

const en_bronze_weak_ape_push = /** @type {(inputs: Bronze_Weak_Ape_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access context`)
};

const de_bronze_weak_ape_push = /** @type {(inputs: Bronze_Weak_Ape_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffs-Kontext`)
};

/**
* | output |
* | --- |
* | "Access context" |
*
* @param {Bronze_Weak_Ape_PushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bronze_weak_ape_push = /** @type {((inputs?: Bronze_Weak_Ape_PushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bronze_Weak_Ape_PushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bronze_weak_ape_push(inputs)
	return de_bronze_weak_ape_push(inputs)
});